<template>
  <div class="jl-auc-modal">
    <div class="jl-auc-modal-body alt-spike">
      <div class="jl-modal-loading-wrap" v-if="isShowLoading" v-loading="true"></div>
      <div class="jl-modal-content1">
        <div class="item">
          <div class="item-type">
            <p class="text1">
              秒杀金额：
              <span class="span1">¥</span>
              <span class="span2">{{seckillPrice}}</span>
            </p>
            <p class="text2">是否确定直接拍得该商品?</p>
          </div>
          <div class="item-footer">
            <button class="btn alt-1" @click="hanleCancel">取消</button>
            <button class="btn confim" @click="hanleConfim">确定</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    seckillPrice: [Number, String]
  },
  data() {
    return {
      isShowLoading: false
    };
  },
  methods: {
    hanleCancel() {
      this.$emit("cancelClick");
    },
    hanleConfim() {
      this.$emit("confimClick", { type: "spike" });
    }
  }
};
</script>

<style lang="scss" scoped>
.jl-auc-modal {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.7);
  .jl-auc-modal-body {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 390px;
    height: 236px;
    margin-left: -195px;
    margin-top: -118px;
    background-color: #fff;
    box-shadow: 0 0 18px rgba(4, 40, 104, 0.3);
    &.alt-spike {
      width: 390px;
      height: 236px;
      margin-left: -195px;
      margin-top: -118px;
    }
  }
  .jl-modal-content1 {
    display: table;
    width: 100%;
    height: 100%;
    text-align: center;
    .item-footer {
      .btn {
        width: 100px;
        height: 42px;
        text-align: center;
        line-height: 42px;
        font-size: 16px;
        color: #333;
        background-color: transparent;
        border: 1px solid #333;
        margin: 0 10px;
        outline: none;
        cursor: pointer;
        &.confim {
          color: #fff;
          background-color: #e50011;
          border-color: #e50011;
        }
      }
    }
    .item {
      display: table-cell;
      vertical-align: middle;
    }
    .item-type {
      .text1 {
        font-size: 16px;
        color: #333;
        margin-bottom: 10px;
        span {
          color: #e50011;
          margin-right: 5px;
        }
        .span1 {
          font-size: 28px;
        }
        .span2 {
          font-size: 36px;
        }
      }
      .text2 {
        font-size: 14px;
        color: #333;
        margin-bottom: 30px;
      }
    }
    .item-spike {
      p {
        display: inline-block;
      }
      .text1 {
        font-size: 20px;
        color: #e50011;
        padding-left: 30px;
        background: url("../../../assets/img/zkj-tips-icon1.png") no-repeat left
          center;
        margin-bottom: 15px;
      }
      .text2,
      .text3 {
        width: 378px;
        font-size: 14px;
        color: #333;
        margin-bottom: 15px;
      }
      .text3 {
        color: #666;
        margin-bottom: 30px;
      }
    }
  }
}
.jl-modal-loading-wrap {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
}
</style>